import React, { useState } from "react";
import { SectionTitle } from "../AddItem/AddItem.styles";
import { useTranslation } from "react-i18next";
import Steps from "../../../../components/Steps/Steps";
import CategoryStep1 from "./CategoryStep1";

const CategoriesPage = () => {
  const { t } = useTranslation();
  const [activeStep, setActiveStep] = useState(1);
  const stepName = [t("category")];

  return (
    <>
      <SectionTitle>{t("categories.categories")}</SectionTitle>
      <Steps
        steps={stepName}
        activeStep={activeStep}
        setActiveStep={setActiveStep}
      />
      {activeStep === 1 && <CategoryStep1 />}
    </>
  );
};

export default CategoriesPage;
